<template>
    <div>
        <b-form-select v-model="selected" @change="onChange">
            <b-form-select-option value="cash"><translate>Cash or private account</translate></b-form-select-option>
            <b-form-select-option value="bank"><translate>Bank transaction</translate></b-form-select-option>
            <b-form-select-option value="credit"><translate>Creditcard</translate></b-form-select-option>
            <b-form-select-option value="notpaid"><translate>Not yet paid</translate></b-form-select-option>
        </b-form-select>
    </div>
</template>
<script>
    export default {
        name: "PaymentTypeSelector",
        props: {
            value: String,
        },
        watch: {
            value: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.selected = newVal;
                }
            }
        },
        components: {},
        data() {
            return {
                selected: null,
                userList: [],
            }
        },
        created(){
            this.selected = this.value;
        },
        methods: {
            initialize(){
            },
            onChange(value){
                this.$emit('input', value);
                this.$emit('change', value);
            },
        }
    };
</script>
<style></style>